import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateAsAgo',
  standalone: false
})
export class DateAsAgoPipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    if (!value) { return 'davno'; }
    let time = (Date.now() - Date.parse(value)) / 1000;
    if (time < 10) {
      return 'upravo sada';
    } else if (time < 60) {
      return 'prije par trenutaka';
    }
    const divider = [60, 60, 24, 30, 12];
    const string = ['sekunda', 'minuta', 'sat', 'dan', 'mjesec', 'godina'];
    let i;
    for (i = 0; Math.floor(time / divider[i]) > 0; i++) {
      time /= divider[i];
    }

    var prije = string[i];
    if (i == 2) {
      (time < 2) ? prije = 'sat' : (time < 5) ? prije = 'sata' : prije = 'sati';
    }
    else if (i == 3) {
      (time < 2) ? prije = 'dan' : prije = 'dana';
    }
    else if (i == 4) {
      (time < 2) ? prije = 'mjesec' : (time < 5) ? prije = 'mjeseca' : prije = 'mjeseci';
    }
    else if (i == 0) {
      (time < 2) ? prije = 'sekunda': (time < 5) ? prije = 'sekunde' : prije = 'sekundi';
    }
    else if (i == 1) {
      (time < 5) ? prije = 'minute' : prije = 'minuta';
    }

    return 'prije ' + Math.floor(time) + ' ' + prije;
  }
}